import { createContext, useContext, useState, useRef, useEffect } from 'react';

const Context = createContext();

export const useFormContext = () => useContext(Context);

export const FormContextProvider = Context.Provider;

function serializeValues(config, values) {
    Object.entries(config).forEach(([k, c]) => {
        if (c.serialize) {
            values[k] = c.serialize(values[k]);
        }
    });
    return values;
}

export function useForm({
    config, initialState, captureSaveHandler, onChange, 
}) {
    const saveHandlersRef = useRef([]);

    const [state, setState] = useState({
        values: initialState,
        errors: {},
    });

    useEffect(() => {
        captureSaveHandler((values) => {
            const saveHandlers = saveHandlersRef.current;
            saveHandlers.forEach(handler => handler(values));
            serializeValues(config, values);
        });
    }, []);

    const onChangeKeyValue = (key, value) => {
        const conf = config[key];
        let parsed = value;

        if (conf) {
            if (value !== null) {
                if (conf.type === 'number') {
                    parsed = parseFloat(value);
                }
            }

            if (conf.onChange) {
                // eslint-disable-next-line no-use-before-define
                conf.onChange(parsed, form);
            }
        }

        setState((st) => {
            const validationResult = conf && conf.validate
                ? conf.validate(parsed, st.values)
                : null;

            const { clearErrorFor } = validationResult && typeof validationResult === 'object' ? validationResult : {};
            const newError = typeof validationResult === 'string' ? validationResult : undefined;

            const newValues = {
                ...st.values,
                [key]: parsed,
            };

            if (onChange) {
                onChange(serializeValues(config, { ...newValues }));
            }

            return {
                ...st,
                values: newValues,
                errors: {
                    ...st.errors,
                    [clearErrorFor || key]: undefined,
                    [key]: newError,
                },
            };
        });
    };

    const handleChange = (e) => {
        if (typeof e === 'object' && 'field' in e && 'value' in e) {
            onChangeKeyValue(e.field, e.value);
        } else if (Array.isArray(e)) {
            e.forEach((change) => {
                if (change) {
                    onChangeKeyValue(change.field, change.value);
                }
            });
        } else {
            const { value } = e.target;
            onChangeKeyValue(e.target.name, value === '' ? null : value);
        }
    };

    const addSaveHandler = (saveHandler) => {
        saveHandlersRef.current.push(saveHandler);
    };

    const form = {
        config,
        values: state.values,
        errors: state.errors,
        setState,
        onChange: handleChange,
        addSaveHandler,
    };

    return form;
}



// WEBPACK FOOTER //
// ./app/components/common/Form/form.jsx